export const VEREDICTO_META = {
  pedir_ya: {
    label: 'Pedir ya',
    className: 'bg-red-100 text-red-800 border-red-300',
    badge: 'bg-red-600 text-white',
  },
  posponer: {
    label: 'Se puede posponer / comprar con cautela',
    className: 'bg-amber-50 text-amber-900 border-amber-300',
    badge: 'bg-amber-500 text-white',
  },
  no_pedir: {
    label: 'No pedir',
    className: 'bg-slate-100 text-slate-800 border-slate-300',
    badge: 'bg-slate-600 text-white',
  },
  liquidacion: {
    label: 'No pedir — liquidación',
    className: 'bg-red-50 text-red-900 border-red-400',
    badge: 'bg-red-800 text-white',
  },
  nuevo_demanda: {
    label: 'Nuevo: solo con demanda latente',
    className: 'bg-orange-50 text-orange-900 border-orange-300',
    badge: 'bg-orange-500 text-white',
  },
};

export const ESTADO_META = {
  borrador: { label: 'Borrador', className: 'bg-gray-100 text-gray-800' },
  pendiente_aprobacion: { label: 'Pendiente aprobación', className: 'bg-yellow-100 text-yellow-900' },
  aprobada: { label: 'Aprobada', className: 'bg-emerald-100 text-emerald-900' },
  rechazada: { label: 'Rechazada', className: 'bg-orange-100 text-orange-900' },
  anulada: { label: 'Anulada', className: 'bg-red-100 text-red-800' },
};

export const formatCop = (val) =>
  Number(val || 0).toLocaleString('es-CO', {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 0,
  });

export const requiresMotivo = (veredicto) =>
  ['no_pedir', 'liquidacion', 'nuevo_demanda'].includes(veredicto);

export const isEditableEstado = (estado) =>
  estado === 'borrador' || estado === 'rechazada';
